var map = {
	"./admin.svg": 6678,
	"./automacao.svg": 72841,
	"./cadastros.svg": 58783,
	"./caixaVistoStroke.svg": 42984,
	"./cell-tower.svg": 67913,
	"./circleArrows.svg": 19771,
	"./circleBox.svg": 13044,
	"./circleCheck.svg": 87567,
	"./circleDocument.svg": 73090,
	"./cliente.svg": 7945,
	"./clientes.svg": 89384,
	"./dashboard.svg": 58703,
	"./dispositivos.svg": 33759,
	"./document.svg": 97450,
	"./dot-fill.svg": 76236,
	"./dot.svg": 5378,
	"./download.svg": 45933,
	"./e-sim.svg": 15668,
	"./edit.svg": 71909,
	"./elipse-preenchida.svg": 68007,
	"./elipse.svg": 52925,
	"./erro-cirle.svg": 57421,
	"./eye-off.svg": 63720,
	"./eye.svg": 31716,
	"./file-upload.svg": 31203,
	"./financeiro.svg": 26431,
	"./fornecedor.svg": 39972,
	"./grip.svg": 4305,
	"./historico.svg": 7349,
	"./icone-detalhamento-consumo.svg": 36391,
	"./icone-fatura.svg": 2245,
	"./icone-olho-ligado.svg": 8297,
	"./icone-seta-dropdown.svg": 67257,
	"./importar.svg": 29019,
	"./informacoes.svg": 20533,
	"./localizacao.svg": 49431,
	"./lockerStroke.svg": 77753,
	"./logo-completo-virtueyes.svg": 54913,
	"./manutencao.svg": 92288,
	"./misc.svg": 78141,
	"./pedidos.svg": 87653,
	"./relatorios.svg": 13381,
	"./signal.svg": 36953,
	"./simbolo-virtueyes.svg": 16127,
	"./simcard-vigem.svg": 46991,
	"./simcard.svg": 50320,
	"./sms.svg": 1444,
	"./solicitacoes.svg": 95713,
	"./star.svg": 14677,
	"./trash.svg": 97781,
	"./upload.svg": 90778,
	"./usuarios.svg": 4550,
	"./vehicle.svg": 72115,
	"./virtueyes.svg": 66215,
	"./warning.svg": 90087
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 90699;